import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { formatDateAndTimeZ, iaRa } from 'lib/helpers/utility';
import { useClinicalNote } from 'lib/hooks/queries/clinicalNotes/useClinicalNotes';

import { currentPractice } from 'components/practice/practiceState';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { findCurrentDOS } from '../lib/helpers';

const DOSLinks = () => {
  const { id: patientId, appointmentId } = useParams();
  const { timezone } = useRecoilValue(currentPractice);
  const navigate = useNavigate();

  const { data: clinicalNoteOptions } = useClinicalNote({
    params: { patientId },
    dependencies: [patientId],
    options: {
      enabled: !!patientId,
      select: (data) =>
        iaRa(data?.clinicalNote).map((note) => ({
          label: formatDateAndTimeZ(note?.appointment?.starts_at, timezone),
          value: note?.appointment?.id,
          className: 'bg-primary-50'
        }))
    }
  });

  const options = [
    ...iaRa(clinicalNoteOptions).map((item) => ({
      label: item?.label,
      onClick: () => navigate(`/portal/charts/${patientId}/clinical-notes/${item.value}`),
      property_of: 'Date of service',
      className: item?.value == appointmentId ? '!bg-primary-25' : ''
    }))
  ];

  return (
    <Popover
      isFixed
      isDropdown
      text={`DOS: ${findCurrentDOS({ options: clinicalNoteOptions, appointmentId })}`}
      position="right"
      iconRightColor="white"
      options={options}
      optionsGroupBy="property_of"
      icon={null}
      iconRight="chevron-down-linear"
      buttonClassName="flex h-[32px] text-[14px] w-[142px] text-white border-none cursor-pointer items-center justify-center rounded-md  bg-primary-800 hover:bg-primary-700 p-0"
      panelClassName="mt-[6px] max-h-80 overflow-y-auto"
      data-qa="chart-links-menu"
    />
  );
};

export default DOSLinks;
